import React from "react"
import PropTypes from "prop-types"
import CurrencyFormat from "common/nibble/CurrencyFormat"

const nf = new Intl.NumberFormat("es-MX")

export default function TableTotal({ totals }) {
  const { payment, deposit, balance_initial } = totals

  return (
    <>
      <tr className="table-head">
        <td colSpan={7} className="f-bold text-right">
          Totales
        </td>
        <td className="f-bold text-right">
          <CurrencyFormat prefix="$" value={deposit} />
        </td>
        <td className="f-bold text-right">
          <CurrencyFormat prefix="$" value={payment} />
        </td>
        <td className="f-bold text-right">
          <CurrencyFormat prefix="$" value={balance_initial} />
        </td>
      </tr>
    </>
  )
}

TableTotal.propTypes = {
  totals: PropTypes.object,
}
